import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-b border-ice-strong bg-white py-12 sm:py-16" data-id="element-223" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-224" data-mp="1t8nki4okdfqy">
        <h2 className="text-center font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl" data-id="element-225" data-mp="1oacb1v26l799">
          <span aria-hidden="true" data-id="element-226" data-mp="1jbiwdzb5ra7i">📊 </span>Die Zahlen lügen nicht
        </h2>
        <dl className="mt-10 grid grid-cols-2 gap-y-10 md:grid-cols-4 md:gap-y-0" data-id="element-227" data-mp="1edhevitdriy5">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ice-strong' : ''}`} data-id="element-228" data-mp="19ky0ijmvcjsa" data-mpi={index}>
              <dt className="sr-only" data-id="element-229" data-mp="10mlyllgjxzkj">{stat.label}</dt>
              <dd data-id="element-230" data-mp="10jq2m2o9lkyq">
                <span className={`block font-display text-4xl font-extrabold tracking-tight sm:text-5xl ${stat.color}`} data-id="element-231" data-mp="vmq3kbpu1ih4">
                  {stat.value}
                </span>
                <span className="mt-2 block text-sm font-semibold text-navy/70" data-id="element-232" data-mp="3oodlptctrnkf">{stat.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}